<rwidget-alert></rwidget-alert>
<ng-container *ngIf="!isDesktop">
    <div class="sticky top-0 z-20 bg-white">
        <div
            class="orb-app-light-dark:min-h-[4rem] flex min-h-[48px] flex-row items-center border-b border-solid border-black border-opacity-10 dark:border-contrast-yellow">
            <div class="flex w-12 justify-start">
                <ion-button
                    class="ml-1"
                    *ngIf="(isBackButtonHidden$ | async) === false"
                    [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
                    (click)="handleBackClicked()"
                    fill="clear">
                    <ion-icon
                        class="var-app-light-dark:text-primary gl-light:text-secondary text-xl dark:filter-yellow"
                        src="{{ assetsPath$ | async }}/img/journey-planner/icon-arrow.svg"></ion-icon>
                </ion-button>
            </div>

            <h1 class="var-app-light-dark:font-bold min-w-0 flex-1 px-2 text-center text-base font-semibold leading-5">
                {{ 'BUY_NEW_TICKET' | translate }}
            </h1>
            <div class="flex w-12 justify-end">
                <ion-button
                    class="mr-1"
                    *ngIf="shouldShowCloseButton"
                    [attr.aria-label]="'LOCAL_BTN_CLOSE' | translate"
                    (click)="handleClosePurchasePage()"
                    fill="clear">
                    <ion-icon
                        class="var-app-light:text-primary text-2xl dark:filter-yellow"
                        [title]="'LOCAL_BTN_BACK' | translate"
                        src="{{ assetsPath$ | async }}/img/explore/cross.svg"></ion-icon>
                </ion-button>
            </div>
        </div>
    </div>
    <div
        *ngIf="isLoading$ | async"
        [ngClass]="(nextButton$ | async) ? 'content-loading-next-button' : 'content-loading'">
        <ridango-ui-basic-loading-spinner></ridango-ui-basic-loading-spinner>
    </div>
    <div
        class="var-app-light:!bg-grey-white_smoke orb-app-light:!bg-grey-white_smoke block overflow-y-auto dark:bg-contrast-black"
        [ngStyle]="{
            display: isNewAfc && (isLoading$ | async) ? 'none' : 'block',
            height: 'calc(100vh - ' + bottomPartSize + ' - var(--ion-safe-area-top) - var(--ion-safe-area-bottom))'
        }">
        <ng-container [ngSwitch]="stepFromUrl$ | async">
            <ng-container *ngIf="dataFromUrl$ | async as dataFromUrl">
                <gl-purchase-v2-ticket-preferences
                    *ngSwitchCase="'preferences'"
                    [preferences]="preferences$ | async"
                    [selectedPreferenceId]="dataFromUrl?.selectedPreferenceId"
                    [savedPreference]="savedPreference$ | async"
                    (nextStep)="handleNextClicked()"
                    (nextButtonElement)="handleNextButtonElement($event)"
                    (selectedOptionChange)="handleSelectedOptionChange($event)">
                </gl-purchase-v2-ticket-preferences>
                <gl-purchase-v2-ticket-areas
                    *ngSwitchCase="'areas'"
                    [areas]="areas$ | async"
                    [selectedAreaId]="dataFromUrl?.selectedAreaId"
                    (nextStep)="handleNextClicked()"></gl-purchase-v2-ticket-areas>
                <ng-container *ngIf="productAreas$ | async as productAreas">
                    <gl-purchase-v2-ticket-product-areas
                        *ngSwitchCase="'product-area'"
                        [selectedArea]="selectedArea$ | async"
                        [productAreas]="productAreas"
                        [selectedProductAreas]="dataFromUrl"
                        [selectedOption]="selectedPreferenceOption$ | async"
                        (nextStep)="handleNextClicked()"
                        (nextButtonElement)="handleNextButtonElement($event)"
                        (errorEvent)="handleErrorEvent($event)"></gl-purchase-v2-ticket-product-areas>
                    <gl-purchase-v2-ticket-category-product
                        *ngSwitchCase="'category-product'"
                        [productAreas]="productAreas"
                        [selectedProductId]="dataFromUrl?.selectedProductId"
                        (nextStep)="handleNextClicked()"
                        (errorEvent)="handleErrorEvent($event)"></gl-purchase-v2-ticket-category-product>
                    <gl-purchase-v2-ticket-product
                        *ngSwitchCase="'product'"
                        [productAreas]="productAreas"
                        [ticketsFromUrl]="dataFromUrl"
                        [activationMode$]="activationMode$"
                        [selectedStartingDate$]="selectedStartingDate$"
                        [ActivationMode]="ActivationMode"
                        [minDate]="minDate"
                        (nextStep)="handleNextClicked()"
                        (nextButtonElement)="handleNextButtonElement($event)"
                        (errorEvent)="handleErrorEvent($event)"
                        (activationModeChange)="onActivationModeChange($event)"
                        (dateChange)="onDateChange($event)">
                    </gl-purchase-v2-ticket-product>
                    <ng-container *ngSwitchCase="'ticket-activation'">
                        <gl-purchase-v2-ticket-activation
                            *ngIf="categoryProducts.length > 0"
                            [categoryProducts]="categoryProducts"
                            [productAreas]="productAreas"
                            (nextButtonElement)="handleNextButtonElement($event)"
                            (nextStep)="handleNextClicked()"></gl-purchase-v2-ticket-activation>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>

    <div class="sticky bottom-0 z-20 bg-white">
        <div class="var-app-light-dark:mt-4 flex w-full bg-white" *ngIf="nextButton$ | async as nextButton">
            <ion-button
                class="next-button tallinn-light:text-white m-4 mb-0 w-full"
                [disabled]="nextButton.disabled"
                (click)="handleNextClicked()"
                size="large">
                <ion-label
                    class="vl-app-light:text-black orb-app-light:text-black orb-app-light-dark:font-semibold sr-app-light:text-white whitespace-normal text-base font-bold normal-case dark:text-contrast-black"
                    [class.gl-light:text-white]="!nextButton.disabled"
                    [class.gl-light:text-black]="nextButton.disabled">
                    {{ nextButton.content.textTerm | translate }}
                    {{
                        nextButton.content.amount
                            ? '(' +
                              (nextButton.content.amount | moneyFormat) +
                              ') ' +
                              (nextButton.content.currency | translate)
                            : ''
                    }}
                </ion-label>
                <ion-icon
                    class="vl-app-light:text-black orb-app-light:text-black sr-app-light:text-white"
                    [class.gl-light:text-white]="!nextButton.disabled"
                    [class.gl-light:text-black]="nextButton.disabled"
                    aria-hidden="true"
                    name="arrow-forward-outline"
                    slot="end"></ion-icon>
            </ion-button>
        </div>
        <div class="h-12 w-full bg-white pb-4">
            <div
                class="flex justify-evenly px-4 pt-4"
                [attr.aria-label]="
                    'STEP_DESCRIPTION'
                        | translate
                            : {
                                  step: activeStep + 1,
                                  total: (steps$ | async).length,
                                  currentStep: activeStep + 1
                              }
                "
                tabindex="0">
                <ng-container *ngFor="let section of steps$ | async; let index = index">
                    <ng-template [ngIf]="index <= activeStep">
                        <ion-icon
                            class="h-3 pb-4 text-5xl text-grey-zambezy dark:text-contrast-yellow"
                            role="none"
                            aria-hidden="true"
                            src="{{ assetsPath$ | async }}/img/purchase-flow-v2/step-active.svg">
                        </ion-icon>
                    </ng-template>
                    <ng-template [ngIf]="index > activeStep">
                        <ion-icon
                            class="h-3 pb-4 text-5xl text-grey-white_smoke dark:text-contrast-yellow dark:opacity-20"
                            role="none"
                            aria-hidden="true"
                            src="{{ assetsPath$ | async }}/img/purchase-flow-v2/step-inactive.svg">
                        </ion-icon>
                    </ng-template>
                </ng-container>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="isDesktop">
    <div class="min-h-[75vh] bg-white">
        <section class="main-grid">
            <div class="flex flex-col gap-12">
                <p class="leading-12 w-60 text-4xl font-medium">{{ 'BUY_NEW_TICKET' | translate }}</p>
                <div
                    class="flex flex-col gap-6 border-t-2 border-solid border-opacity-5 pt-2 dark:border-contrast-yellow">
                    <div
                        class="flex items-center"
                        *ngFor="let section of steps$ | async; let index = index"
                        [ngClass]="{ 'opacity-50': index > activeStep }">
                        <ion-icon
                            class="mr-4 text-xl dark:filter-yellow"
                            src="{{ assetsPath$ | async }}/img/purchase-flow-v2/step-desktop.svg"></ion-icon>
                        <ion-label class="text-base" [ngClass]="{ 'font-bold': index === activeStep }">{{
                            section.description | translate
                        }}</ion-label>
                    </div>
                </div>
            </div>
            <main class="lg:col-start-2 lg:col-end-4">
                <div class="content-loading" *ngIf="isLoading$ | async">
                    <ridango-ui-basic-loading-spinner></ridango-ui-basic-loading-spinner>
                </div>
                <gl-purchase-v2-base (nextButtonElement)="populateNextButton($event)"></gl-purchase-v2-base>

                <div class="flex h-32 items-center" [ngClass]="{ 'justify-between': nextButton$ | async }">
                    <ion-button
                        class="normal-case"
                        *ngIf="(isBackButtonHidden$ | async) === false"
                        (click)="handleBackClicked()"
                        color="secondary"
                        fill="clear">
                        <ion-icon class="mr-4" name="arrow-back-outline"></ion-icon>
                        {{ 'PREVIOUS_BUTTON' | translate }}
                    </ion-button>

                    <ion-button
                        class="next-button tartu-light:text-white tallinn-light:text-white w-80 dark:border-contrast-yellow"
                        *ngIf="nextButton$ | async as nextButton"
                        [disabled]="nextButton.disabled"
                        (click)="handleNextClicked()"
                        size="large">
                        <ion-label
                            class="vl-app-light:text-black whitespace-normal text-base font-bold normal-case dark:text-contrast-black"
                            [class.gl-light:text-white]="!nextButton.disabled"
                            [class.gl-light:text-black]="nextButton.disabled">
                            {{ nextButton.content.textTerm | translate }}
                            {{
                                nextButton.content.amount
                                    ? '(' +
                                      (nextButton.content.amount | moneyFormat) +
                                      ') ' +
                                      (nextButton.content.currency | translate)
                                    : ''
                            }}
                        </ion-label>
                        <ion-icon
                            class="vl-app-light:text-black dark:text-contrast-black"
                            [class.gl-light:text-white]="!nextButton.disabled"
                            [class.gl-light:text-black]="nextButton.disabled"
                            name="arrow-forward-outline"
                            slot="end"></ion-icon>
                    </ion-button>
                </div>
            </main>
        </section>
    </div>
</ng-container>
